import React from 'react';

import { Textarea, FormField, Form } from '@amzn/awsui-components-react-v3';
interface useCaseProps {
  value: string;
  formSubmitted?: boolean;
  onChange?: (event: string | undefined) => void;
}

const UseCaseComponent = (props: useCaseProps) => {
  const handleUseCaseChange = (event: CustomEvent | undefined) => {
    if (!!props.onChange) props.onChange(event.detail.value);
  };

  return (
    <Form>
      <FormField
        label={'Use case (required)'}
        description={'Provide a brief description of how you are planning to use this data.'}
        errorText={props.formSubmitted && !props.value && 'Use case is required.'}
      >
        <Textarea value={props.value} onChange={handleUseCaseChange} placeholder='Enter use case' />
      </FormField>
    </Form>
  );
};

export default UseCaseComponent;
